import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { Box, TextField, Typography } from "@material-ui/core";
import SwitchField from "components/Forms/SwitchField";
import { NOTIFICATION_LIMITS } from "@dashboard-v3/shared";
import { AdvancedOptionsContainer } from "components/Styled";
import { StyledDetails, StyledSummary } from "../Actions/Styled";
import { useRuleContext } from "../../context/ruleContext";
import { getSmimeActionState } from "pages/Rules/Form/context/ruleSelectors";

export default function AdvancedOptions() {
  const { t } = useTranslation("rules");
  const { state, dispatch } = useRuleContext();
  const { failedAction } = getSmimeActionState(state.rule);
  const showFailedAction = failedAction.addSubjectInvalidSmime;

  const onFailedActionChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked } = e.target;
    const update = { ...failedAction };

    if (name === "addSubjectInvalidSmime") {
      update.addSubjectInvalidSmime = checked;
      update.subjectInvalidSmime = "";
    }

    if (name === "subjectInvalidSmime") {
      update.subjectInvalidSmime = value;
    }

    dispatch({
      type: "updateStep",
      payload: {
        step: "smimeAction",
        changes: { failedAction: update },
      },
    });
  };

  return (
    <AdvancedOptionsContainer>
      <StyledSummary>
        <Typography>{t("advancedOptions")}</Typography>
      </StyledSummary>
      <StyledDetails>
        <SwitchField
          name="addSubjectInvalidSmime"
          style={{ marginBottom: showFailedAction ? 10 : 0 }}
          label={t("smime.enableFailedAction.label")}
          description={!showFailedAction && t("smime.enableFailedAction.desc")}
          value={failedAction.addSubjectInvalidSmime}
          onChange={onFailedActionChange}
        />
        {showFailedAction && (
          <Box display="flex" flexDirection="column" maxWidth="90%">
            <TextField
              name="subjectInvalidSmime"
              variant="outlined"
              label={t("smime.invalidSubject.label")}
              value={failedAction.subjectInvalidSmime}
              onChange={onFailedActionChange}
              inputProps={{ maxLength: NOTIFICATION_LIMITS.SUBJECT_TAG }}
            />
          </Box>
        )}
      </StyledDetails>
    </AdvancedOptionsContainer>
  );
}
